module.exports = __webpack_public_path__ + "07717b2f3dbaa95197c268541bff97a6.png";